// extracted by mini-css-extract-plugin
export default {"container":"Highlighter_container__TUL73","backdrop":"Highlighter_backdrop__sydbp"};